import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { userReducer } from '@shared/api/reduxToolkit';
import { USER_KEY } from '@shared/constants';

const userPersistConfig = {
	key: USER_KEY,
	version: 1,
	storage,
	whitelist: ['accountMembershipId', 'user'],
};

export const persistedUserReducer = persistReducer(userPersistConfig, userReducer);
